import { Grid, GridCol, Modal, TextInput } from "@mantine/core"
import { showNotification } from "@mantine/notifications"
import { Button } from "@tfg/ui"
import { Dispatch, SetStateAction, useState } from "react"
import { useTranslation } from "react-i18next"

import {
  CreateBusinessPartnerRequestDto,
  UpdateBusinessPartnerRequestDto,
} from "~/gen/api/types"
import { useCreateContactByEmailMutation } from "~/pages/Brand/Suppliers/SuppliersRepository/hooks/useCreateContactByEmailMutation"
import { SUPPLIER_INITIAL_VALUES } from "~/pages/Brand/Suppliers/SuppliersRepository/index"

type Props = {
  opened: boolean
  onClose: () => void
  openDrawer: () => void
  setInitialValues: Dispatch<
    SetStateAction<
      CreateBusinessPartnerRequestDto | UpdateBusinessPartnerRequestDto
    >
  >
  searchSupplier: string
}

export function SupplierCreationModal({
  opened,
  onClose,
  openDrawer,
  setInitialValues,
  searchSupplier,
}: Props) {
  const [email, setEmail] = useState("")
  const { t } = useTranslation("organizationSettings")

  const { mutateAsync: createSupplierMappingByEmail } =
    useCreateContactByEmailMutation({
      searchSupplier,
    })

  const handleCreateSupplierMappingByEmail = async () => {
    const { data } = await createSupplierMappingByEmail({
      data: { email },
    })
    if (data) {
      showNotification({
        title: "Supplier created",
        message: `Supplier created successfully`,
        color: "teal",
      })
      setEmail("")
      onClose()
    } else {
      setInitialValues((prev) => ({
        ...prev,
        ...SUPPLIER_INITIAL_VALUES,
        email,
      }))
      setEmail("")
      onClose()
      openDrawer()
    }
  }

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={t("supplierSettings.addNewSupplier")}
      p="md"
      centered
    >
      <Modal.Body p={0}>
        <Grid w="100%" pr="md">
          <GridCol span={10}>
            <TextInput
              value={email}
              onChange={(event) => setEmail(event.currentTarget.value)}
              placeholder={t("supplierSettings.supplierEmail")}
            />
          </GridCol>
          <GridCol span={2}>
            <Button onClick={handleCreateSupplierMappingByEmail}>
              {t("supplierSettings.submit")}
            </Button>
          </GridCol>
        </Grid>
      </Modal.Body>
    </Modal>
  )
}
